import React from "react";
import { connect } from "react-redux";
import MMPLShipCard from "./MMPLShipCard";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipPO,
  getMMPLShipCount,
  getMMPLShipSearch,
  getPriorityShipCount,
} from "../Actions/MMPLDashboardAPI";
import ShipPOs from "./ShipPOs";
import Moment from "moment";
import CountUp from "react-countup";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { getShipnameList } from "../Actions/HelpersAPI";
import MMPLDashboardShip from "./MMPLDashboardShip";
import MMPLPriorityDashboardShip from "./MMPLPriorityDashboardShip";

class PriorityDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterTitle: "All Ships",
      showPendingTask: false,
      searchShip: {
        ShipName: "",
        PageSize: 25,
      },
      PageNo: 1,
      PgSize: 25,
      EquipmentList: [],
      shipId: 0,
      shipName: "",
      poValidationShipName: "",
      isShortClosed: false,
      isIhmPart1: false,
      isAwaitingMdAndSdoc: false,
      isPoValidation: false,
      isPurchaseOrders: true,
      isShipsPendingTask: false,
      TotalShip: false,
      shipSuccess: false,
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.renderMovieTitle = this.renderMovieTitle.bind(this);
    this.SearchShipPOs = this.SearchShipPOs.bind(this);
    this.getShipDetails = this.getShipDetails.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
  }

  componentDidMount() {
    const { dispatch, SearchResult,match } = this.props;
    dispatch({ type: "POSuccess", data: "" });
    dispatch({ type: "SubBannerTitle", data: "PRIORITY LIST" });
    dispatch(getPriorityShipCount(this.state.shipId));
    dispatch(getShipnameList());
    if (SearchResult) {
      dispatch(getShipPO(SearchResult, SearchResult.PageNo));
    } else {
      dispatch(getShipPO(this.state, this.state.PageNo));
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, ShipNameList, SearchResult } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }
    if (ShipNameList) {
      prevState.EquipmentList = ShipNameList;
    }
    if (SearchResult && SearchResult !== "" && !prevState.shipSuccess) {
      prevState.poValidationShipName = SearchResult.poValidationShipName;
      prevState.shipName = SearchResult.shipName;
      prevState.isPurchaseOrders = SearchResult.isPurchaseOrders;
      prevState.isPoValidation = SearchResult.isPoValidation;
      prevState.isAwaitingMdAndSdoc = SearchResult.isAwaitingMdAndSdoc;
      prevState.isIhmPart1 = SearchResult.isIhmPart1;
      prevState.isShortClosed = SearchResult.isShortClosed;
      prevState.TotalShip = SearchResult.TotalShip;
      prevState.shipSuccess = true;
    }
  }

  getShipDetails(action) {
    const { dispatch } = this.props;
    if (action === 1) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = true;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 2) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = true;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 3) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = true;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 4) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = true;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "PurchaseOrders", data: false });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 5) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = true;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getShipPO(this.state, this.state.PageNo));
    } else {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = true;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    }
    this.setState({ showClientDetails: false, filterclientDetails: false });
  }
  ClearPoSearchField() {
    this.state.poValidationShipName = "";
    this.props.dispatch(getShipPO(this.state, this.state.PageNo));
    this.setState({});
  }

  SearchShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLShipSearch(this.state, PgNo));
  }

  ClearShipSearchField() {
    this.state.shipName = "";
    this.props.dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({});
  }

  handlePOInputChange(e) {
    this.state.poValidationShipName = e.target.value;
    this.setState({});
  }

  handleShipInputChange(e) {
    this.state.shipName = e.target.value;
    this.setState({});
  }
  SearchShipPOs(action) {
    const { dispatch } = this.props;
    dispatch(getShipPO(this.state));
  }

  renderMovieTitle(state, val) {
    return state.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  handleInputChanges(e, field) {
    this.state[field] = e.target.value;
    this.setState({});
  }

  handleSelectChange(value, field) {
    this.state[field] = value;
    this.setState({});
  }

  render() {
    const {
      shipMMPLInfo,
      equipmentInfo,
      MMPLSidePanCollectDocs,
      shipMMPLCount,
      MMPLShipList,
      ShipPO,
    } = this.props;
    const {
      isShortClosed,
      isIhmPart1,
      isAwaitingMdAndSdoc,
      isPoValidation,
      isPurchaseOrders,
      TotalShip,
      PurchaseOrders,
    } = this.state;
    return (
      <div className="full-height pt-3">
        {/* <div className="row">
          <div className="col-lg-1" style={{ minWidth: "16%" }}>
            <div className={`${isPurchaseOrders ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.getShipDetails(4)} >
              <h1 className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}mb-0 mt-2`} style={{ color: 'rgb(235,125,9)' }}><CountUp start={0} end={shipMMPLCount ? shipMMPLCount.pOs : 0} duration={2.00} separator="," /></h1>
              <h5 className={`${MMPLSidePanCollectDocs ? "f-1 " : " "}text-center`}>Purchase Orders</h5>
            </div>
          </div>
          <div className="col-lg-1" style={{ minWidth: "18%" }}>
            <div className={`${isPoValidation ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.getShipDetails(1)} >
              <h1 className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}mb-0 mt-2`} style={{ color: 'rgb(230,9,9)' }}><CountUp start={0} end={shipMMPLCount ? shipMMPLCount.poValidation : 0} duration={2.00} separator="," /></h1>
              <h5 className={`${MMPLSidePanCollectDocs ? "f-1 " : " "}text-center`}>My Pending Tasks - PO Validation</h5>
            </div>
          </div>
          <div className="col-lg-1" style={{ minWidth: "16%" }}>
            <div className={`${isAwaitingMdAndSdoc ? "a " : ""}card card-selector p-2 mb2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.getShipDetails(2)} >
              <h1 className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}mb-0 mt-2`} style={{ color: 'rgb(255,122,9)' }}><CountUp start={0} end={shipMMPLCount ? shipMMPLCount.collectMdocSdoc : 0} duration={2.00} separator="," /></h1>
              <h5 className={`${MMPLSidePanCollectDocs ? "f-1 " : " "}text-center`}>Awaiting MD & SDoc</h5>
            </div>
          </div>
          <div className="col-lg-1" style={{ minWidth: "18%" }}>
            <div className={`${isIhmPart1 ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.getShipDetails(3)} >
              <h1 className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}mb-0 mt-2`} style={{ color: 'rgb(249,230,5)' }}><CountUp start={0} end={shipMMPLCount ? shipMMPLCount.ihmPart1 : 0} duration={2.00} separator="," /></h1>
              <h5 className={`${MMPLSidePanCollectDocs ? "f-1 " : " "}text-center`}> My Pending Tasks - IHM Part 1 Update</h5>
            </div>
          </div>
          <div className="col-lg-1" style={{ minWidth: "16%" }}>
            <div className={`${isShortClosed ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.getShipDetails(5)} >
              <h1 className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}mb-0 mt-2`} style={{ color: 'rgb(200,200,5)' }}><CountUp start={0} end={shipMMPLCount ? shipMMPLCount.shortClosed : 0} duration={2.00} separator="," /></h1>
              <h5 className={`${MMPLSidePanCollectDocs ? "f-1 " : " "}text-center`}> Short Closed - PO's</h5>
            </div>
          </div>
          <div className="col-lg-1" style={{ minWidth: "16%" }}>
            <div className={`${TotalShip ? "a " : ""}card card-selector mb2 p-2 text-center`} style={{ height: "135px", marginBottom: 0 }} onClick={() => this.getShipDetails('noAction')} >
              <h1 className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}mb-0 mt-2`}><CountUp start={0} end={shipMMPLCount ? shipMMPLCount.totalShips : 0} duration={2.00} separator="," /></h1>
              <h5 className={`${MMPLSidePanCollectDocs ? "f-1 " : " "}text-center`}>Total Ships</h5>
            </div>
          </div>
        </div> */}
        <MMPLPriorityDashboardShip />
        {/* {this.state.TotalShip ? (
          <>
            <div className="row my-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div className="card MM-card-header m-auto" style={{ backgroundColor: "white" }}>
                    <div className="card-body">
                      <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>All Ships</h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: '12px' }}>
                      <div className="col-lg-6">
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="shipName"
                          placeholder="Ship Name"
                          onChange={(e) => this.handleShipInputChange(e)}
                          value={this.state.shipName}
                        ></input>
                      </div>

                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div className="mt-3 search-btn-col" style={{ textAlign: "end" }}>
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchShips(1)}
                          >
                            {" "}Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearShipSearchField()}
                          >
                            {" "}Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {MMPLShipList ? (
              <MMPLShipCard
                arraylist={MMPLShipList.data}
                pageSize={MMPLShipList.pagination.pageSize}
                totalRecords={MMPLShipList.pagination.totalcount ? MMPLShipList.pagination.totalcount : 0}
                setUpdatedState={(value) => this.SearchShips(value)}
              />
            ) : null}
          </>
        ) : null} */}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI
    shipMMPLCount: state.MMPLDashboardReducer.PriorityShipMMPLCount,
    shipMMPLDetail: state.MMPLDashboardReducer.shipMMPLDetail || {},
    shipMMPLSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || [],
    shipMMPLInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
    MMPLShipList: state.MMPLDashboardReducer.MMPLShipList,
    poSearchResult: state.MMPLDashboardReducer.MMPLPOShipSearchResult,
    mDocSearchResults: state.MMPLDashboardReducer.MMPLMdocShipSearchResult,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    ShortClosedSearchResults:
      state.MMPLDashboardReducer.MMPLShortClosedShipSearchResult,
    ShipPO: state.MMPLDashboardReducer.ShipPOs,
    ShipNameList: state.UserManageReducer.ShipNameList,
    SearchResult: state.MMPLDashboardReducer.SearchResult,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PriorityDashboard);
